import type { Product } from '@/services/products';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  readonly products: readonly Product[];
}

export const ProductGrid = ({ products }: ProductGridProps) => {
  if (products.length === 0) {
    return (
      <div
        className="text-center"
        style={{
          paddingTop: 'var(--space-16)',
          paddingBottom: 'var(--space-16)',
        }}
      >
        <p
          style={{
            fontSize: 'var(--text-lg)',
            color: 'var(--text-tertiary)',
          }}
        >
          No products found
        </p>
      </div>
    );
  }

  return (
    <div
      className="grid"
      style={{
        gap: 'var(--space-6)',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 260px), 1fr))',
      }}
    >
      {products.map((product) => (
        <ProductCard key={product.productId} product={product} />
      ))}
    </div>
  );
};
